/*****************************
上下スクロールで対象にクラスを付与するクラス
ver 1.0.0

メニューや、トップに戻るボタンの出し入れに使う。

# usage
var scroll_amount = new CaracolScrollAmount( target, {config} );

## target
検知対象となる element

## config
パラメーター。値は初期値。

{
	up: 80,  // 上へのスクロールに反応するスクロール積算値。
	down: 80,  // 下へのスクロールに反応するスクロール積算値。
	offset_top: 50, // スクロール位置がこの値より上ならページ最上部と判断
	offset_bottom: 50, // スクロール位置がこの値より下ならページ最下部と判断

	// 状態によって付与されるクラス
	class:{
		pinned: 'ccl-amount_pinned',
		unpinned: 'ccl-amount_unpinned',
		top: 'ccl-amount_top',
		nottop: 'ccl-amount_not-top',
		bottom: 'ccl-amount_bottom',
		notbottom: 'ccl-amount_not-bottom',
		initial: 'ccl-amount'
	},

	// イベント
	onPin: function(){},
	onUnPin: function(){},
	onTop: function(){},
	onNotTop: function(){},
	onBottom: function(){},
	onNotBottom: function(){}
}

------------------------
ver1.0.0 2016/11/22
- とりあえず作った。

*/
var CaracolScrollAmount;

module.exports = CaracolScrollAmount = function( target, config ){
	'use strict';

	var defaults = {
		up: 80,
		down: 80,
		offset_top: 70,
		offset_bottom: 70,

		// 状態によって付与されるクラス
		class:{
			pinned: 'ccl-amount_pinned',
			unpinned: 'ccl-amount_unpinned',
			top: 'ccl-amount_top',
			nottop: 'ccl-amount_not-top',
			bottom: 'ccl-amount_bottom',
			notbottom: 'ccl-amount_not-bottom',
			initial: 'ccl-amount'
		},
		// イベント
		onPin: function(){},
		onUnPin: function(){},
		onTop: function(){},
		onNotTop: function(){},
		onBottom: function(){},
		onNotBottom: function(){}
	};

	this.opt = $.extend( defaults, config );
	this.target = target;
	this.$target = $(target);
	this.$window =$(window);
	this.win_height = null;	// ブラウザウィンドウの高さ
	// this.doc_height = null;	// ドキュメントの高さ
	this.last_scroll = 0; // 1回前の座標
	this.count_scroll = 0; // スクロール量の積算

	this.is_started = false; // 開始した
	this.is_top = false; // 一番上にスクロールした
	this.is_bottom = false; // 一番下にスクロールした
	this.is_pinned = false; // ピンを立てた

	// 開始
	this.start();
};

/********************
* スクロール検知処理を開始
*/
CaracolScrollAmount.prototype.start = function(){
	'use strict';

	// すでに開始していたら無視
	if( this.is_started ) return;

	// 基礎クラスを付与
	this.$target.addClass( this.opt.class.initial );

	// リサイズイベントでドキュメント高さチェック
	this.resize();
	this.$window.on('resize', $.throttle( 100, $.proxy( this.resize, this )));

	// スクロールイベント
	this.scroll();
	this.is_started = true;
	this.$window.on('scroll', $.throttle( 100, $.proxy( this.scroll, this )));

	// 一応1秒間毎にチェックも入れる
	setInterval( $.proxy( this.scroll, this ), 1000 );
};

/********************
* スクロール検知処理を停止
*/
CaracolScrollAmount.prototype.stop = function(){
	'use strict';
	this.$window.off( 'scroll', _.throttle( $.proxy( this.scroll, this ), 50 ) );
};
/********************
* スクロール処理
*/
CaracolScrollAmount.prototype.scroll = function(){
	'use strict';

	var opt = this.opt;
	var scroll = this.$window.scrollTop();
	var distance = scroll - this.last_scroll; // 移動量

	// 位置イベントのチェック
	this.check_top_bottom( scroll );

	// スクロール量を積算。もし逆方向にスクロールしたらリセット
	if( this.count_scroll > 0 && distance > 0 ){
		this.count_scroll += distance;
	}else if( this.count_scroll < 0 && distance < 0 ){
		this.count_scroll += distance;
	}else{
		this.count_scroll = distance;
	}

	this.last_scroll = scroll;

	// スクロールが規定量越えたらピンを立てる
	if(  this.count_scroll >= opt.down && !this.is_pinned ){
		// 下にスクロール
		this.is_pinned = true;
		this.$target.addClass( opt.class.pinned );
		this.$target.removeClass( opt.class.unpinned );

	}else if( this.count_scroll <= -opt.up && this.is_pinned ){
		// 上にスクロ−ル
		this.is_pinned = false;
		this.$target.addClass( opt.class.unpinned );
		this.$target.removeClass( opt.class.pinned );
	}

};

/********************
* 最上部か最下部かのチェック
*/
CaracolScrollAmount.prototype.check_top_bottom = function( scroll ){
	'use strict';

	var opt = this.opt;
	var $target = this.$target;
	var scroll_bottom = $(document).height() - this.win_height;


	if( !this.is_top && scroll <= opt.offset_top ){
		// ページ最上部
		this.is_top = true;
		$target.addClass( opt.class.top );
		$target.removeClass( opt.class.nottop );
		$target.addClass( opt.class.notbottom );
		opt.onTop();

	}else if( !this.is_bottom && scroll >= scroll_bottom - opt.offset_bottom){
		// ページ最下部
		this.is_bottom = true;
		$target.addClass( opt.class.bottom );
		$target.addClass( opt.class.nottop );
		$target.removeClass( opt.class.notbottom );
		opt.onBottom();

	}else if( this.is_top && scroll > opt.offset_top ){
		// 最上部から離れた
		this.is_top = false;
		$target.addClass( opt.class.nottop );
		$target.removeClass( opt.class.top );
		opt.onNotTop();

	}else if( this.is_bottom && scroll < scroll_bottom - opt.offset_bottom ){
		// 最下部から離れた
		this.is_bottom = false;
		$target.addClass( opt.class.notbottom );
		$target.removeClass( opt.class.bottom );
		opt.onNotBottom();
	}
};


/********************
* ウィンドウをリサイズしたら高さなどをチェック
*/
CaracolScrollAmount.prototype.resize = function(){
	this.win_height = this.$window.height();
}




/*****************
 ** WEBPACK FOOTER
 ** /Users/dada/www/_template/.src/js/caracol2.0.0/effect/scroll_amount.js
 ** module id = 5
 ** module chunks = 0
 **/